import React, { Component } from "react";

class Message extends Component {
    render() {
        return <span />;
    }
}

export default Message;
